<section class="partners">
  <div class="partners--container">
    <h2 class="partners--title">Initiative By</h2>
    <div class="partners--list">
      <div
        *ngFor="let partner of partners; let i = index"
        class="partner--item"
        [attr.aria-label]="partner.name"
      >
        <a
          *ngIf="partner.website; else noLink"
          [href]="partner.website"
          target="_blank"
          rel="noopener noreferrer"
          class="partner--link"
        >
          <span class="partner--logo-wrap">
            <img
              [src]="partner.logo"
              [alt]="partner.name"
              class="partner--logo"
              loading="lazy"
            />
            <span *ngIf="i === 0" class="partner--caption">{{ partner.name }}</span>
          </span>
        </a>
        <ng-template #noLink>
          <span class="partner--logo-wrap">
            <img
              [src]="partner.logo"
              [alt]="partner.name"
              class="partner--logo"
              loading="lazy"
            />
            <span *ngIf="i === 0" class="partner--caption">{{ partner.name }}</span>
          </span>
        </ng-template>
      </div>
    </div>
  </div>
</section>

